import { defineStyleConfig } from '@chakra-ui/react'

export const Tooltip = defineStyleConfig({
    baseStyle: {
        bg: 'white',
        borderColor: 'blackAlpha.200',
        borderWidth: 1,
        fontSize: '12px',
        color: 'gray.700',
        rounded: 'lg',
        '--popper-arrow-bg': 'white',
    },
})
